.timerContainer {
  padding: 10px 15px;
  border-radius: var(--Common--border-radius);
  background-color: var(--theme-secondary-background);
  display: flex;
  justify-content: center;
  align-items: center;
}

.leftPanel {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.activeControls {
  display: flex;
  flex-direction: row;
  justify-content: center;
  user-select: none;
}

.timerText {
  font-size: 42px;
  text-align: center;
  color: var(--theme-primary-text);
}

.timerText.orange,
.widgetText.orange {
  color: var(--aha-orange-500);
}

.timerText.red,
.widgetText.red {
  color: var(--aha-red-700);
}

.timerText.paused,
.widgetText.paused,
.widgetIcon.paused {
  color: var(--theme-tertiary-text);
}

.timerText.timeUp {
  font-size: 26px;
}

.alarm {
  margin: auto;
  font-size: 24px;
}

.addTimeButton {
  width: 42px;
  height: 24px;
  margin: 5px;
  font-size: 12px;
  line-height: 2em;
  text-align: center;
  color: var(--aha-button--color);
  border-radius: var(--Common--border-radius);
  border: 1px solid var(--theme-button-gray);
  background-color: var(--theme-button-gray);
  cursor: pointer;
}

.addTimeButton:focus-visible,
.addTimeButton[focused],
.addTimeButton:hover,
.addTimeButton[hovered],
.addTimeButton:active,
.addTimeButton[active] {
  background-color: var(--theme-button-gray-hovered);
  border-color: var(--theme-button-gray-hovered);
}
.addTimeButton:active,
.addTimeButton[active] {
  background-color: var(--theme-button-gray);
}

.inactiveControls {
  margin-right: 30px;
  display: flex;
  align-items: center;
  user-select: none;
  text-align: center;
}

#timerInput {
  width: 70px;
  height: 40px;
  margin: 0;
  box-shadow: none;
  border-radius: 0px;
  border: 1px solid var(--theme-button-border);
  font-size: 16px;
  font-weight: 400;
  text-align: center;
}

.sideButton {
  width: 30px;
  height: 48px;
  line-height: 48px;
  margin: 0;
  border: 1px solid var(--theme-button-border);
  font-size: 12px;
  font-weight: 900;
  color: var(--theme-primary-text);
  background-color: var(--theme-button);
  cursor: pointer;
}

.sideButton:first-child {
  border-left: 1px solid var(--theme-button-border);
  border-right: none;
  border-radius: var(--Common--border-radius) 0 0 var(--Common--border-radius);
}

.sideButton:last-child {
  border-left: none;
  border-right: 1px solid var(--theme-button-border);
  border-radius: 0 var(--Common--border-radius) var(--Common--border-radius) 0;
}

#timerInput:focus-visible,
#timerInput[focused],
#timerInput:hover,
#timerInput[hovered],
#timerInput:active,
#timerInput[active],
.sideButton:focus-visible,
.sideButton[focused],
.sideButton:hover,
.sideButton[hovered],
.sideButton:active,
.sideButton[active] {
  background-color: var(--theme-button-hovered);
  border-color: var(--theme-button-border-hovered);
}
#timerInput:active,
#timerInput[active],
.sideButton:active,
.sideButton[active] {
  background-color: var(--theme-button);
}

.rightPanel {
  width: 50%;
  display: flex;
  justify-content: flex-end;
}

.pauseButton {
  width: 78px;
  margin-right: 11px;
  font-size: 13px;
  line-height: 2em;
  text-align: center;
  border: 1px solid var(--theme-button-primary);
  border-radius: var(--Common--border-radius);
  color: var(--theme-light-text);
  background-color: var(--theme-button-primary);
  cursor: pointer;
  user-select: none;
}

.pauseButton:focus-visible,
.pauseButton[focused],
.pauseButton:hover,
.pauseButton[hovered],
.pauseButton:active,
.pauseButton[active] {
  background-color: var(--theme-button-primary-hovered);
  border-color: var(--theme-button-primary-hovered);
}
.pauseButton:active,
.pauseButton[active] {
  background-color: var(--theme-button-primary);
}

.stopButton {
  width: 60px;
  font-size: 13px;
  line-height: 2em;
  text-align: center;
  border: 1px solid var(--theme-button-border);
  border-radius: var(--Common--border-radius);
  color: var(--theme-primary-text);
  background-color: var(--theme-button);
  cursor: pointer;
  user-select: none;
}

.stopButton:focus-visible,
.stopButton[focused],
.stopButton:hover,
.stopButton[hovered],
.stopButton:active,
.stopButton[active] {
  background-color: var(--theme-button-hovered);
  border-color: var(--theme-button-border-hovered);
}
.stopButton:active,
.stopButton[active] {
  background-color: var(--theme-button);
}

.widgetContainer {
  width: 120px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--theme-button);
  border-radius: var(--Common--border-radius);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
}

.widgetIcon {
  margin-right: 8px;
  font-size: 14px;
  line-height: 2em;
}

.widgetIcon.paused {
  font-size: 16px;
}

.widgetText {
  color: var(--aha-blue-500);
  font-size: 16px;
  line-height: 2em;
}

.widgetText.expired {
  font-size: 14px;
  padding-right: 5px;
}

.close {
  position: absolute;
  right: 6px;
  top: 6px;
  color: var(--aha-gray-500);
  cursor: pointer;
  user-select: none;
}
